import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
    DossierDossierReadNoteGroupTimestampableBlameambleGroup,
    DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup,
    DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup,
    FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { FORMALITES_REDUCER_NAME } from './constants';
import { buildFormaliteRedux } from './formalitesReducer';

const { reducer } = buildFormaliteRedux({});

export const formalityReducer = combineReducers({
    [FORMALITES_REDUCER_NAME]: reducer,
});

export const formalityStore = configureStore({
    reducer: formalityReducer,
    devTools: {
        name: 'Formalités Store',
    },
});

export type FormalityReducerType = typeof formalityReducer;
export type FormalityStateType = ReturnType<typeof formalityStore.getState>;
export type FormalityAppDispatch = typeof formalityStore.dispatch;
export type DossierJsonldRead = DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup;
export type DossierArticlesPatchResponseJsonldRead =
    DossierDossiersArticlesPatchResponseDtoJsonldDossierReadNoteGroupTimestampableBlameambleGroup;
export type DossierPrestationJsonldRead =
    FproPrestationJsonldDossierReadNoteGroupTimestampableBlameambleGroup;
export type DossierRead = DossierDossierReadNoteGroupTimestampableBlameambleGroup;
